import React from 'react'

import "./Home.css"
import { Link } from 'react-router-dom'
import logo from '../../../assets/imgs/logo/logo.png'
import HomeSection1 from './homeSection1/HomeSection1'
import HomeSection2 from './homeSection2/HomeSection2'
import HomeSection3 from './homeSection3/HomeSection3'
import HomeSection4 from './homeSection4/HomeSection4'

import homeSec5 from "../../../assets/imgs/homeSec5.png"
import Footer from '../../Footer/Footer'
import HomeSection5 from './homeSection5/HomeSection5'
import HomeSection6 from './homeSection6/HomeSection6'

function Home() {
  return (
    <div id="home" style={{
      overflowX: 'hidden'
    }}>
      <div className="mob-nav">
        <div className="close-mob-nav" onClick={()=>{
          document.getElementsByClassName('mob-nav')[0].style.animation = 'nav-out 0.17s ease-out 1 normal forwards'
        }}>
        <i class="fa-solid fa-xmark"></i>
        </div>
        <div className="page" style={{color:'white'}}>HOME</div>
        <div className="page"><Link to='/products'>PRODUCTS</Link></div>
        <div className="page">ABOUT</div>
        <div className="page">BLOGS</div>
        <div className="page">SERVICES</div>
        <div className="btn1"><button>Download App</button></div>
        <div className="btn2"><button>Login</button></div>
      </div>
      <div className="top">
        <div className="top-content">
          <div className="quote" id='quot-btn' onClick={()=>{
            document.getElementById('req-quot').style.animation = 'box-in 0.2s ease-out 0.1s 1 forwards normal'
            document.getElementById('quot-btn').style.animation = 'box-out 0.2s ease-in 0.1s 1 forwards normal'
          }}>
            <b>
              Get Quote
            </b>
          </div>
          <div className="req-quote" id='req-quot'>
            <div id='close-quot' onClick={()=>{
            document.getElementById('req-quot').style.animation = 'box-out 0.2s ease-in 0.1s 1 forwards normal'
            document.getElementById('quot-btn').style.animation = 'box-btn-in 0.2s ease-out 0.1s 1 forwards normal'
            }}>
              <i class="fa-solid fa-xmark"></i>
            </div>
            <div style={{color:'white'}}><h3>Contact Us</h3></div>
            <div><input type="text" placeholder='Name' /></div>
            <div><input type="text" placeholder='Address'/></div>
            <div><input type="text" placeholder='Email Id'/></div>
            <div><input type="text" placeholder='Phone Number'/></div>
            <div><input type="text" placeholder='Area of Place'/></div>
            <div><input type="button" value="Submit" /></div>
          </div>
          <div className="nav">
            <div className="logo">
              <img src={logo} alt="" />
            </div>
            <div className="ham" onClick={()=>{
              document.getElementsByClassName('mob-nav')[0].style.animation = 'nav-in 0.17s ease-out 1 normal forwards'
            }}>
              <i class="fa-solid fa-bars"></i>
            </div>
            <div className="nav-items">
              <div className="page" style={{color:'white'}}>HOME</div>
              <div className="page"><Link to='/products'>PRODUCTS</Link></div>
              <div className="page"><Link to='/about'>ABOUT</Link></div>
              <div className="page"><Link to='/blog'>BLOGS</Link></div>
              <div className="page"><Link to='/service'>SERVICES</Link></div>
              <div className="btn1"><button>Download App</button></div>
              <div className="btn2"><button>Login</button></div>
            </div>
          </div>
          <div className="tagline">
            <div>
              <b>The new way to create <br/>
                  your next IoT product or service
              </b>
            </div>
            <div>
              <button>Get Started</button>
            </div>
          </div>
        </div>
      </div>
      <HomeSection1/>
      <HomeSection2/>
      <HomeSection3/>
      <HomeSection4/>
      <img src={homeSec5} alt="" style={{
        marginTop:'2rem',
        width:'100%',
      }} />
      <HomeSection5/>
      <HomeSection6/>
      <Footer />
    </div>
  )
}

export default Home
